module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/logo08-ecd465fa9c03373115e67f26347c7862.png";